import { render, staticRenderFns } from "./report-filter-group.vue?vue&type=template&id=10b874f2&"
import script from "./report-filter-group.vue?vue&type=script&lang=ts&"
export * from "./report-filter-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports